 <!-- <nz-skeleton [nzAvatar]="true" [nzActive]="true" [nzTitle]="true" [nzLoading]="fetchingProposalIOs"> -->

 <div class="heading-tab">
   <h3 class="heading"><i nz-icon nzType="file-protect" nzTheme="outline"></i> Policy</h3>
   <button *ngIf="enableAddPolicy" nz-button nzType="primary" (click)="openPolicySearch()">Search / Add</button>
 </div>

 <div class="search-results m-t-20">
   <nz-table #policySearchTable [nzData]="policyList" [nzSize]="'middle'">
     <thead>
       <tr>
         <th>Proposal No</th>
         <th>Product</th>
         <th>Owner Name</th>
         <!-- <th>Client Phone</th> 
        <th>Role</th>-->
         <th>Status</th>
         <th>Actions</th>
       </tr>
     </thead>


     <tbody>
       <tr *ngFor="let item of policySearchTable.data || []">
         <td>{{item.proposalNum}}</td>
         <td>{{(proposalIODataPointsList[item.proposalNum]?.baseProductCd | technicalTranslate) || 'Fetching Policy...'}}
         </td>
         <td>{{(proposalIODataPointsList[item.proposalNum]?.ownerFullName | technicalTranslate) || 'Fetching Policy...'}}
         </td>
         <td>{{(proposalIODataPointsList[item.proposalNum]?.statusCd | technicalTranslate) || 'Fetching Policy...'}}</td>
         <!-- <td><a nz-popconfirm nzTitle="Remove Policy from intimation?" nzOkText="Remove"
                nzCancelText="Cancel">Remove</a></td> -->
         <td><a *ngIf="enableRemovePolicy && !enableCopy" nz-popconfirm nzPopconfirmTitle="Remove Policy from intimation?"
             nzOkText="Remove" nzCancelText="Cancel"
             (nzOnConfirm)="removePolicy(item,policyList,'proposalNum')">Remove</a></td>
       </tr>
     </tbody>


   </nz-table>
 </div>
 <!-- </nz-skeleton>  -->
